export default __webpack_public_path__ + "static/media/cfs.8e692442.png";